import {translation} from "@2d-front-monorepo/core";
import {Loading} from "@2d-front-monorepo/design-library";
import {JSX} from "react";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import Loader from "./Loader";

export default function PermitsLoading({title = PermitTranslations.website__application_loading}:{title?:string}): JSX.Element {
	return <Loading label={translation(title)}>
		<Loader />
	</Loading>;
}
